import { useSearchParams } from 'react-router-dom'
import Layout from '../components/layouts/index'
import Tabs from '../components/modules/tabs/Tabs'
import { VisionDelNegocio } from '../components/modules/views/dashboard/BusinessInsights/VisionDelNegocio/VisionDelNegocio'
import Presupuesto from '../components/modules/views/dashboard/BusinessInsights/Presupuesto/Index'
import Reportes from '../components/modules/views/dashboard/BusinessInsights/Reportes/Reportes'
import ResumenImpuestos from '../components/modules/views/dashboard/BusinessInsights/ResumenImpuestos/ResumenImpuestos'
import { BusinessInsightProvider } from '../components/modules/views/dashboard/BusinessInsights/VisionDelNegocio/VisionContext/businessInsightContext'

const TAB_SLUGS = ['vision-negocio', 'presupuesto', 'reportes', 'proyeccion-f29']

export default function BusinessInsights() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const activeTab = TAB_SLUGS.includes(tabParam) ? TAB_SLUGS.indexOf(tabParam) : 0

  const handleTabChange = index => {
    setSearchParams({ tab: TAB_SLUGS[index] }, { replace: true })
  }

  const tabs = [
    {
      title: 'Vision del negocio',
      content: <VisionDelNegocio onGoToResumen={() => handleTabChange(3)} />
    },
    { title: 'Presupuesto', content: <Presupuesto /> },
    { title: 'Reportes', content: <Reportes /> },
    { title: 'Proyeccion F29', content: <ResumenImpuestos /> }
  ]

  return (
    <Layout>
      <BusinessInsightProvider>
        <Tabs tabs={tabs} activeIndex={activeTab} onTabClick={handleTabChange} />
      </BusinessInsightProvider>
    </Layout>
  )
}
